import { Phone, MapPin, Facebook } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/mgckb403_1.png";
const BRAND_URL = "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/q3hz0127_2.jpg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { href: "#about", label: "About Us" },
    { href: "#services", label: "Our Services" },
    { href: "#gallery", label: "Gallery" },
    { href: "#testimonials", label: "Reviews" },
    { href: "#contact", label: "Contact" },
  ];

  const services = [
    "Driveways",
    "Patios",
    "Garden Design",
    "Grounds Maintenance",
    "Tree Surgery",
    "Hedge Cutting",
  ];

  return (
    <footer className="bg-[#1A4D2E] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="mb-6 flex items-center gap-1">
              <img 
                src={LOGO_URL} 
                alt="Pioneer Trees mascot" 
                className="h-14 w-auto"
              />
              <img 
                src={BRAND_URL} 
                alt="Pioneer Trees and Landscapes Ltd" 
                className="h-12 w-auto rounded"
              />
            </div>
            <p className="text-white/70 leading-relaxed mb-6">
              Specialists in landscaping, driveways, patios, garden design and tree surgery, based in and around Northumberland. Contract or private basis.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/pioneertreesandlandscapes" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                aria-label="Facebook"
                data-testid="footer-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a 
                    href={link.href} 
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <a 
                    href="#services" 
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Contact Us</h4>
            <div className="space-y-4">
              <a 
                href="tel:07968790128" 
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5 text-[#D97706]" />
                07968 790128
              </a>
              <a 
                href="https://www.facebook.com/pioneertreesandlandscapes" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
              >
                <Facebook className="w-5 h-5 text-[#D97706]" />
                Message us on Facebook
              </a>
              <div className="flex items-start gap-3 text-white/70">
                <MapPin className="w-5 h-5 text-[#D97706] flex-shrink-0 mt-1" />
                <span>
                  15 Second Row<br />
                  Ellington<br />
                  NE61 5HE
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/60">
          <p>&copy; {currentYear} Pioneer Trees and Landscapes Ltd. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
